module.exports = __webpack_public_path__ + "images/emoji/ambulance.73412b0203625735f8be.png";